import { FC, useState } from 'react';
import { VITE_COMMIT_HASH, VITE_BUILD_TIMESTAMP } from '../../config/viteEnv';

/**
 * Bottom-right beaker icon that shows commit hash and build timestamp.
 * Click to toggle info panel. Click hash to copy.
 * Only renders when VITE_COMMIT_HASH is set (i.e., started via start-dev.sh).
 */
export const DevInfoWidget: FC = () => {
  const commitHash = VITE_COMMIT_HASH;
  const buildTimestamp = VITE_BUILD_TIMESTAMP;
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  if (!commitHash) return null;

  const copyHash = () => {
    navigator.clipboard.writeText(commitHash).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    }).catch(() => {
      // Clipboard API unavailable (non-HTTPS, iframe restrictions, etc.)
    });
  };

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 12,
        right: 12,
        zIndex: 99999,
        userSelect: 'text',
      }}
    >
      {open && (
        <div
          style={{
            position: 'absolute',
            bottom: 40,
            right: 0,
            background: '#1e1e2e',
            color: '#cdd6f4',
            padding: '8px 12px',
            borderRadius: 6,
            fontSize: 12,
            fontFamily: 'monospace',
            whiteSpace: 'nowrap',
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
            lineHeight: 1.8,
          }}
        >
          <div>
            <strong style={{ color: '#89b4fa' }}>commit </strong>
            <span
              onClick={copyHash}
              style={{ cursor: 'pointer', textDecoration: 'underline', textDecorationStyle: 'dotted' }}
              title="Click to copy"
            >
              {commitHash}
            </span>
            {copied && <span style={{ color: '#a6e3a1', marginLeft: 6 }}>copied!</span>}
          </div>
          <div><strong style={{ color: '#89b4fa' }}>built </strong>{buildTimestamp}</div>
        </div>
      )}
      <div
        onClick={() => setOpen(prev => !prev)}
        style={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          background: open ? '#45475a' : '#31324488',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 16,
          cursor: 'pointer',
          transition: 'background 0.15s',
        }}
        title={`${commitHash} — ${buildTimestamp}`}
      >
        🧪
      </div>
    </div>
  );
};
